import { Component, OnInit, ViewChild, ElementRef, Input, HostListener } from '@angular/core';
import { AuthenticationService } from '../../../_Services/user/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';

import { UserModel } from '../../../_Models/user/user.model';
import { HrService } from '../../../_Services/hr/hr.service';
import { UserType, HeaderCount, BookingSearchRedirectPage, HRProfileEnum, Url, RoleEnum, WormsServicePortal, ITSupporEmail, Permission, NumberOne } from '../../common/static-data-common';
import { DataServiceService } from "../../../_Services/common/data-service-service.service";
import { HeaderService } from '../../../_Services/header/header.service';
import { TaskResult, TaskMessage, TaskType, TaskSearchRequest, TaskFilterType, TaskDateType } from '../../../_Models/header/task.model';
import { WorkerMiddlewareService } from '../../../_Services/common/worker.service';
import { ToastrService } from 'ngx-toastr';
import { NotifactionDateType, NotificationFilterType, NotificationMessage, NotificationResult, NotificationSearchRequest, NotificationType } from '../../../_Models/header/notification.model';
import { CustomerKAMDetail } from 'src/app/_Models/user/customerkamdetails.model';
import { CustomerService } from 'src/app/_Services/customer/customer.service';
import { UtilityService } from 'src/app/_Services/common/utility.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/_Services/common/common.service';
import { PermissionService } from 'src/app/_Services/common/permission.service';
import { DefaultUrlRequest, FBReportAccessType } from 'src/app/_Models/common/common.model';
import { TranslateService } from '@ngx-translate/core';

export const broadCastChannel = new BroadcastChannel('authentication');
import { HeaderMasterModel } from 'src/app/_Models/header/HeaderMasterModel.model';
import { NgSelectComponent } from '@ng-select/ng-select';
import { isThisTypeNode } from 'typescript';
import { UserAccountService } from 'src/app/_Services/UserAccount/useraccount.service';
import { Subscription, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IOAuthService } from 'src/app/_Services/user/iOAuthService';
import { TimeTrackerService } from 'src/app/_Services/common/time-tracker.service';
import { MenuItemModel } from 'src/app/_Models/user/menuItem.model';
const config = require("src/assets/appconfig/appconfig.json");
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('open', style({
        'width': '*',
        'opacity': 1,
        'margin-right': '20px',
        'margin-left': '8px'
      })),
      state('close', style({
        'width': '0px',
        'opacity': '0',
        'margin-right': '0px',
        'margin-left': '0px'
      })),
      transition('open <=> close', animate(300))
    ])
  ]
})
export class HeaderComponent {
  imagePath: string;
  public masterModel: HeaderMasterModel;
  orgImagePath: string;
  products: Array<any>;
  selectedProduct: any;
  hasDarkTheme: boolean;
  enableThemeToggle: boolean;
  //toggleNotification: boolean;
  public User: UserModel;
  public notificationList: Array<NotificationMessage>;
  public header: Array<any>;
  returnUrl: string;
  userEntity: string;
  expandNavigation: boolean;
  public rights: Array<MenuItemModel> | null;
  drawerIsOpen: boolean;
  userProfileImage: string;
  photourl: string;
  _userTypeId;
  usergender: string;
  _internalusertype = UserType.InternalUser;
  _customerusertype = UserType.Customer;
  _headercount = HeaderCount.count;
  selectedId: number;

  _fbReportAccessType = FBReportAccessType;
  _taskType = TaskType;
  @ViewChild('main-wrapper') mainWrapper: ElementRef;
  @ViewChild('drawer-menu-container') drawerContainer: ElementRef;
  @ViewChild('ngNotificationSelectComponent') ngNotificationSelectComponent: NgSelectComponent;
  @ViewChild('ngTaskSelectComponent') ngTaskSelectComponent: NgSelectComponent;
  _userType = UserType;
  customerKAMDetail: CustomerKAMDetail;
  itSupporEmail: string;
  iconList = {};
  permission: any = Permission;
  isChangePasswordAccess: boolean = false;
  isUserGuideAccess: boolean = false;
  @ViewChild('headerSecondColumnElement') headerSecondColumnElement: ElementRef;
  @ViewChild('headerSecondColumnLastChild') headerSecondColumnLastChild: ElementRef;
  @Input() commonHeader: boolean;
  isMobile: boolean;
  data: any;
  subscription: Subscription;
  private scriptLoaded = false;
  isFeedbackLoading: boolean = false;

  intervalId: any;
  activeMenuId: number;

  @HostListener('document:click', ['$event']) public onClick(event) {
    let dropdownClick = false;
    let notificationTrigger = document.querySelector('#notificationTrigger');
    let notificationContainer = document.querySelector('#notificationContainer');
    let notificationDropdown = document.querySelector('#notificationDropdown');
    let taskDropdown = document.querySelector('#taskDropdown');

    ['ng-option', 'ng-option-label'].forEach((className) => {
      if (event.target.classList.contains(className)) { dropdownClick = true; }
    });

    if (
      notificationContainer &&
      notificationTrigger &&
      notificationDropdown &&
      !notificationContainer.contains(event.target) &&
      !notificationTrigger.contains(event.target) &&
      !notificationDropdown.contains(event.target) &&
      !dropdownClick
    ) {
      this.masterModel.showNotificationPanel = false;
    }

    let taskTrigger = document.querySelector('#taskTrigger');
    let taskContainer = document.querySelector('#taskContainer');

    if (
      taskTrigger &&
      taskContainer &&
      taskDropdown &&
      !taskTrigger.contains(event.target) &&
      !taskContainer.contains(event.target) &&
      !taskDropdown.contains(event.target) &&
      !dropdownClick
    ) {
      this.masterModel.showTaskPanel = false;
    }

    if (this._userTypeId == this._customerusertype || (this.User && this.User.isSupportIconIsShow)) {
      let helpTrigger = document.querySelector('#helpTrigger');
      let helpContainer = document.querySelector('#helpContainer');

      if (!helpTrigger?.contains(event.target) && !helpContainer?.contains(event.target)) {
        this.masterModel.showHelpPanel = false;
      }

      // let userTrigger = document.querySelector('#userTrigger');
      // let userContainer = document.querySelector('#userContainer');

      // if (userTrigger && userContainer && !userTrigger.contains(event.target) && !userContainer.contains(event.target)) {
      //   this.masterModel.showUserPanel = false;
      // }
    }
  }
  constructor(private authenticationService: AuthenticationService, private router: Router, private customerService: CustomerService,
    private service: HrService, private ds: DataServiceService, public headerService: HeaderService, public utility: UtilityService,
    private workerService: WorkerMiddlewareService, private toastr: ToastrService, private commonService: CommonService,
    private activeRoute: ActivatedRoute, private permissionSerive: PermissionService,
    private translate: TranslateService, public accService: UserAccountService, private trackerService: TimeTrackerService) {
    this.expandNavigation = false
    this.drawerIsOpen = false;
    this.isChangePasswordAccess = this.permissionSerive.isAnyGranted([Permission.Change_Password_List]);
    this.isUserGuideAccess = this.permissionSerive.isAnyGranted([Permission.UserGuide_List]);
    this.utility.currentUserSubject.subscribe(value => {
      let user = this.authenticationService.getCurrentUser();

      this.User = user;
    })
    this.utility.langSubject.subscribe(value => {
      //console.log(`Part 1 received: ${value}`);
      let user = this.authenticationService.getCurrentUser();

      this.User = user;
      this.rights = this.User?.rights;
      this.orgImagePath = this.User.orgImagePath;
      this.userProfileImage = this.User.profileImage;
      if (this.userProfileImage == null || this.userProfileImage == undefined || this.userProfileImage == '') {
        this.userProfileImage = 'assets/images/new-set/light/default-profile.svg';
      }
      if (this.User?.packageFeatures != null && this.User?.packageFeatures.length > 0) {
        // if (localStorage.getItem('service'))
        //  this.selectedId = Number(localStorage.getItem('service'));
      }
      //to check the header count if greater than 7 (Main Menu)
      this.header = new Array();
      if (this.User?.rights.length >= this._headercount) {
        for (let i = this._headercount; i < this.User?.rights.length; i++) {
          this.header.push(this.User?.rights[i])
        }
      }
    });

    this._userTypeId = this.User?.usertype;
    this.photourl = './assets/images/default-profile.svg';
    //this.GetUserDetails();
    this.ds.currentDrawerState.subscribe((data) => {
      this.drawerIsOpen = data;
    });

    //get the customer KAM Details
    this.customerKAMDetail = new CustomerKAMDetail();
    // this.getCustomerKAMDetails();
    this.itSupporEmail = ITSupporEmail;
    this.masterModel = new HeaderMasterModel();
    this.getNotDoneTotalTaskCount();
    this.getUnReadTotalNotificationCount();
    workerService.subscribeOnGetTask((data) => {
      // show  toast for new task
      // this.toastr.info(data.Message, data.Title);
      this.getNotDoneTotalTaskCount();
      this.getUnReadTotalNotificationCount();
      // refresh tasks
      this.getTasks();
    });

    // set defualt lang with local storeage
    this.getLanguages();


    workerService.subscribeOnGetNotification((data) => {
      // show  toast for new notification
      // this.toastr.info(data.Message, data.Title);
      this.getNotDoneTotalTaskCount();
      this.getUnReadTotalNotificationCount();
      // refresh notification
      this.getNotifications();
    });
    this.returnUrl = this.activeRoute.snapshot.queryParams['returnUrl'] || '/';

    //this.userEntity = this.utility.getEntityName();
    this.enableThemeToggle = this.User?.routes.includes(this.router.url);
    // subscribing to the change in currentDrawerState subject
    this.ds.currentDrawerState.subscribe((data) => {
      this.drawerIsOpen = data;
    });

    this.ds.currentTheme.subscribe(data => {
      this.hasDarkTheme = data;
      this.getThemePath();
    })
    this.hasDarkTheme = this.commonService.checkCurrentTheme();
    this.getThemePath();
    this.getIsMobile();
    localStorage.setItem('serviceName', 'Dashboard');
  }
  ngOnInit() {
    this.intervalId = setInterval(() => {
      if (!this.workerService.iSSubscribUser()) {
        this.getNotDoneTotalTaskCount();
        this.getUnReadTotalNotificationCount();
      }
    }, (config.PULLING_INTERVAL_IN_MIN * 60 * 1000));
    this.trackerService.startTracking();
    const storedId = localStorage.getItem('_activemenuid');

    if (storedId) {
      this.activeMenuId = Number(storedId);
    }
    // If already on PLM landing → trigger PIP selection
    const currentUrl = this.router.url;
    if (currentUrl.includes('plmlandingdashboard')) {
      if (localStorage.getItem('currentUser')) {
        var user = JSON.parse(localStorage.getItem('currentUser'));
      }
      const pipItem = user.packageFeatures.find(
        (x) => x.name === 'PIP' && x.isActive
      );

      if (pipItem) {
        this.RedirectWithServiceAccess(pipItem.id, pipItem);
      }
    }
    if (currentUrl.includes('userDashBoard/dashboard')) {
      if (localStorage.getItem('currentUser')) {
        var user = JSON.parse(localStorage.getItem('currentUser'));
      }
      const VendorItem = user.packageFeatures.find(
        (x) => x.name === 'Vendor' && x.isActive
      );
      if (VendorItem) {
        this.RedirectWithServiceAccess(VendorItem.id, VendorItem);
      }
    }
  }



  ngOnDestroy() {
    if (this.subscription) {
      console.log(this.User.rights, "bxghb")
      this.subscription.unsubscribe();
    }
    this.trackerService.stopTracking();
  }
  ngAfterViewInit() {

    this.getIsMobile();
    this.getHeaderSize();

    this.header = new Array();
    if (this.User.rights.length >= this._headercount) {
      for (let i = this._headercount; i < this.User.rights.length; i++) {
        this.header.push(this.User.rights[i])
      }
    }

  }
  getIsMobile() {
    if (window.innerWidth < 450) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    //console.log(this.isMobile);
  }
  getThemePath() {
    if (this.hasDarkTheme) {

      this.imagePath = `${environment.newImagePath}/dark`;
      this.photourl = './' + this.imagePath + this.photourl;
      this.iconList = this.darkIconList;
    }
    else {
      this.imagePath = `${environment.newImagePath}/light`;
      this.photourl = './' + this.imagePath + this.photourl;
      this.iconList = this.lightIconList;
    }
  }



  lightIconList = {
    1: "assets/images/new-set/light/inspection-navigation.svg",
    3: "assets/images/new-set/light/audit-navigation.svg",
    4: "assets/images/new-set/light/tracing-navigation.svg",
    48: "assets/images/new-set/light/lab-navigation.svg",
    46: "assets/images/new-set/light/analytic-navigation.svg",
    53: "assets/images/new-set/light/sustain-navigation-disabled.svg",
    47: "assets/images/new-set/light/tcf-navigation.svg",
    49: "assets/images/new-set/light/data-navigation.svg",
    50: "assets/images/new-set/light/plm-navigation-disabled.svg",
    51: "assets/images/new-set/light/compliance-navigation-disabled.svg",
    52: "assets/images/new-set/light/academy-navigation-disabled.svg"
  }
  darkIconList = {
    1: "assets/images/new-set/dark/inspection-navigation.svg",
    3: "assets/images/new-set/dark/audit-navigation.svg",
    4: "assets/images/new-set/dark/tracing-navigation.svg",
    48: "assets/images/new-set/dark/lab-navigation.svg",
    46: "assets/images/new-set/dark/analytic-navigation.svg",
    53: "assets/images/new-set/dark/sustain-navigation-disabled.svg",
    47: "assets/images/new-set/dark/tcf-navigation.svg",
    49: "assets/images/new-set/dark/data-navigation.svg",
    50: "assets/images/new-set/dark/plm-navigation-disabled.svg",
    51: "assets/images/new-set/dark/compliance-navigation-disabled.svg",
    52: "assets/images/new-set/dark/academy-navigation-disabled.svg"
  }
  toggleSidebar() {
    this.expandNavigation = !this.expandNavigation;
  }


  async getLanguages() {
    try {
      const langs = await this.authenticationService.getLanguages();
      const addLang = langs?.map((l: any) => l.langPrefix) || [];
      this.translate.addLangs(addLang.length > 0 ? addLang : ['en', 'fr']);
      this.translate.use(localStorage.getItem("lang") || 'en')
    } catch (error) {

    }
  }

  // redirect() {
  //   this.authenticationService.redirectToLanding();
  // }


  getMenuParentId(menuId: number): void {
    this.activeMenuId = menuId;
    localStorage.setItem('_activemenuid', String(menuId));
  }

  geturl(item: MenuItemModel) {
    return "/" + item.path;
  }

  // function to toggle hamburger
  openHamburger() {
    if (this.drawerIsOpen) {
      this.drawerIsOpen = !this.drawerIsOpen;
      (<HTMLElement>document.querySelector('.main-wrapper')).classList.remove('drawer-active');
      (<HTMLElement>document.querySelector('.drawer-menu-container')).classList.remove('active');
    }
    else {
      this.drawerIsOpen = !this.drawerIsOpen;
      (<HTMLElement>document.querySelector('.main-wrapper')).classList.add('drawer-active');
      (<HTMLElement>document.querySelector('.drawer-menu-container')).classList.add('active');
    }
  }
  public signOut() {
    broadCastChannel.postMessage('Logout');
  }
  setBlobFile(blob) {
    if (blob) {
      var reader = new FileReader();
      reader.readAsDataURL(blob); // read file as data url
      reader.onload = (event) => { // called once readAsDataURL is completed
        this.photourl = (<FileReaderEventTarget>event.target).result;
      }
    }
  }
  // GetUserDetails() {
  //   if (this._userTypeId == this._internalusertype) {
  //     this.service.GetGender()
  //       .subscribe((res) => {
  //         if (res && res.result == 1) {
  //           this.usergender = res.gender;
  //           if (res.isPhotovailable)
  //             this.GetPhoto();
  //         }
  //         else {
  //           // this.photourl = './assets/images/default-profile.svg';
  //           this.photourl = './' + this.imagePath + this.photourl;
  //         }
  //       },
  //         error => console.log(error)
  //       );

  //   }
  //   else {
  //     // this.photourl = './assets/images/default-profile.svg';
  //     this.photourl = './' + this.imagePath + this.photourl;
  //   }
  // }
  // GetPhoto() {
  //   if (this._userTypeId == this._internalusertype) {
  //     this.service.getPicture(this.User?.staffId).subscribe(data => {
  //       this.setBlobFile(data);
  //     }, error => {
  //       this.SetPhoto();
  //     });
  //   }
  // }
  SetPhoto() {
    if (this._userTypeId == this._internalusertype) {
      if (this.photourl && this.usergender == 'M')
        this.photourl = this.imagePath + '/images/male.jpg';
      else if (this.photourl && this.usergender == 'F')
        this.photourl = this.imagePath + '/images/female.jpg';
      return this.photourl;
    }

  }

  public getNotificationDetail(item: any) {
    var linkuri = '';
    if (item.notification.type == NotificationType.InspectionReportValidated || item.notification.type == NotificationType.AutoInspectionCertificate || item.notification.type == NotificationType.AuditReportValidated) {
      linkuri = `${item.link}/2/${item.reportNo}`
    } else {
      linkuri = `${item.link}/${item.linkId}`
    }
    this.router.navigate([linkuri]);

    this.readNotification(item.notification.id);
  }
  readNotification(id: string) {
    this.headerService.readNotification(id)
      .pipe()
      .subscribe(
        res => {
          if (res && res.result == 1) {
            this.getNotifications();
          }
          else {
          }
        },
        error => {
          console.error(error);
        });
  }
  public getNotifications() {
    this.masterModel.notifiactionLoader = true;
    const request = new NotificationSearchRequest();
    request.skip = this.masterModel.notifiactionSkip;
    request.notificationType = this.masterModel.notificationType;
    request.isRead = this.masterModel.notificationIsRead;
    this.headerService.getNotifications(request)
      .pipe()
      .subscribe(
        res => {
          if (res && res.result == NotificationResult.Success) {
            let result = res.data.filter(x => !this.masterModel.notificationList.some(y => x.id === y.notification.id));
            result.map(x => {
              if (x.type == NotificationType.InspectionReportValidated || x.type == NotificationType.AutoInspectionCertificate || x.type == NotificationType.AuditReportValidated) {
                this.masterModel.notificationList.push(new NotificationMessage(x, `${x.message} #${x.reportNo}`,
                  x.link, x.linkId, x.reportNo, x.queryParameter,
                  x.iconName));
              } else
                if (x.type == NotificationType.PimAttributes || x.type == NotificationType.PimBillOfMaterials || x.type == NotificationType.PimTestingStandard || x.type == NotificationType.PimDocuments) {
                  let replacedStr = this.getMessage(x);
                  x.typeLabel = `PIM - ${x.reportNo}`
                  this.masterModel.notificationList.push(new NotificationMessage(x, `${replacedStr}`,
                    x.link, x.linkId, x.reportNo, x.queryParameter,
                    x.iconName));
                } else if (x.type == NotificationType.Vendor || x.type == NotificationType.PO) {
                  this.masterModel.notificationList.push(new NotificationMessage(x, `${x.message}`,
                    x.link, x.linkId, x.reportNo, x.queryParameter,
                    x.iconName));
                }
                else if (x.type == NotificationType.BookingComment || x.type == NotificationType.AuditComment || x.type == NotificationType.LabBookingComment || x.type == NotificationType.LabReportComment) {
                  x.typeLabel = `${x.typeLabel} - #${x.reportNo}`
                  this.masterModel.notificationList.push(new NotificationMessage(x, x.message,
                    x.link, x.linkId, x.reportNo, x.queryParameter,
                    x.iconName));
                }
                else {
                  const numberPart = x.designNumber ? `#${x.designNumber}` : `#${x.linkId}`;
                  this.masterModel.notificationList.push(new NotificationMessage(x, `${x.message} ${numberPart}`,
                    x.link, x.linkId, x.reportNo, x.queryParameter,
                    x.iconName));
                }
            });
            this.masterModel.todayNotificationList = this.masterModel.notificationList.filter(x => x.notification.dateType == NotifactionDateType.Today);
            this.masterModel.yesterdayNotificationList = this.masterModel.notificationList.filter(x => x.notification.dateType == NotifactionDateType.Yesterday);
            this.masterModel.olderNotificationList = this.masterModel.notificationList.filter(x => x.notification.dateType == NotifactionDateType.Older);
            this.masterModel.notifiactionLoader = false;
          }
          else {
            this.masterModel.notifiactionLoader = false;
          }
        },
        error => {
          console.error(error);
          this.masterModel.notifiactionLoader = false;
        });
  }
  getMessage(notification: any) {
    let userName: string;
    if (notification?.userTypeId) {
      switch (notification?.userTypeId) {
        case 2:
          userName = notification?.customerContactName;
          break;
        case 3:
          userName = notification?.supplierContactName;
          break;
        case 4:
          userName = notification?.factoryContactName;
          break;
        default:
          userName = '';
      }
    }
    return notification?.message.replace("{0}", `${userName}`).replace("{1}", `${notification?.typeLabel}`);
  }

  toggleAccordion(event) {
    let current = event.currentTarget.parentElement.querySelector('.accordion').style.display;
    event.currentTarget.parentElement.querySelector('.accordion').style.display = current == 'block' ? 'none' : 'block';
  }

  redirectToProfilePage() {
    this.router.navigate(["/" + Url.UserProfile + this.User?.id]);
  }

  //open the email window with to address
  openEmailWindow() {
    window.open("https://wormsgroup.atlassian.net/servicedesk/customer/portal/11", "_blank");
    //window.location.href = "mailto:" + ITSupporEmail;
  }



  loadJiraCollectorScript(): void {
    if (this.scriptLoaded) {
      this.showJiraDialog(); // Only trigger if script is already loaded
      return;
    }

    this.scriptLoaded = true;

    const scriptId = 'jira-collector-script';
    if (document.getElementById(scriptId)) {
      this.showJiraDialog();
      return;
    }

    (window as any).ATL_JQ_PAGE_PROPS = {
      triggerFunction: (showCollectorDialog: any) => {
        (window as any)._showJiraCollectorDialog = showCollectorDialog;
      }
    };

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.src = 'https://wormsgroup.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/vf1kch/b/9/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issuecollector-plugin:issuecollector.js?locale=en-US&collectorId=dbc90b8c';

    script.onload = () => {
      setTimeout(() => this.showJiraDialog(), 1000); // Wait a moment to ensure script initializes
    };

    document.body.appendChild(script);
  }

  showJiraDialog(): void {
    const dialogFn = (window as any)._showJiraCollectorDialog;
    if (dialogFn) {
      dialogFn();
    } else {
      console.error('Jira dialog function not available.');
    }
  }
  redirectUserManual() {
    let path = "/userguide/user-guide";
    let data = {};
    if (this.selectedId && this.selectedId >= 0) {
      data = { featureId: this.selectedId };
    }
    this.router.navigate([path], { queryParams: data });
  }




  //navigateto worms service portal
  navigateToWormsServicePortal() {
    window.open(
      WormsServicePortal,
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  hasManyChildren(children: any[]): boolean {
    return children.length > 10;
  }

  RedirectWithServiceAccess(service, item) {
    this.activeMenuId = 0;
    if (this.expandNavigation)
      this.expandNavigation = !this.expandNavigation;
    this.selectedId = service;
    //set the selected service
    localStorage.setItem('service', JSON.stringify(service));
    if (item && item.name)
      localStorage.setItem('serviceName', item.name);
    //update the current user and assign back to user object
    this.User = this.authenticationService.getCurrentUser();
    //redirect to page specific to the selected service

    let RoleType = this.User.roles.map(x => { return x.roleType; });
    let userType = this.User.usertype;

    let defaultUrlRequest = new DefaultUrlRequest();
    defaultUrlRequest.featureId = service;
    defaultUrlRequest.RoleTypes = RoleType;
    defaultUrlRequest.UserType = userType;

    this.customerService.GetDefaultFeatureUrl(defaultUrlRequest).subscribe(res => {
      if (res?.defaultUrl) {
        const finalUrl = res.defaultUrl;
        this.router.navigate([finalUrl]);

      } else {
        console.log("default URL is null", res);
      }
    },
      error => {
        console.log(error);
      });
  }

  themeChange(event) {
    if (!environment.darkModeEnabledUrls.includes(this.router.url)) { return; }

    let input = event.target.value;
    this.hasDarkTheme = input == 1 ? false : true;
    this.commonService.updateThemeData(this.hasDarkTheme);

    this.ds.changeTheme(this.hasDarkTheme);
  }
  getNotDoneTotalTaskCount() {
    const request = new TaskSearchRequest();
    request.skip = 0;
    request.taskType = null;
    request.isDone = false;

    this.headerService.taskCount(request).subscribe(data => {
      this.masterModel.taskTotalCount = data.totalCount;
    }, error => {
      console.log(error)
    });
  }
  toggleNotification(event, navTarget) {
    this.masterModel.notificationType = null;
    this.resetNotificationList();
    this.resetTaskList();
    this.masterModel.taskType = null;
    this.getNotDoneTotalTaskCount();
    this.getUnReadTotalNotificationCount();
    if (navTarget == 'notificationContainer') {
      this.masterModel.showNotificationPanel = !this.masterModel.showNotificationPanel;
      if (this.masterModel.showNotificationPanel) {
        if (this.ngNotificationSelectComponent)
          this.ngNotificationSelectComponent.clearModel();
        this.getNotifications();
        this.getNotificationCount();
        this.getNotificationType();
      }

    }
    else
      if (navTarget == 'taskContainer') {
        this.masterModel.showTaskPanel = !this.masterModel.showTaskPanel;
        if (this.masterModel.showTaskPanel) {
          if (this.ngTaskSelectComponent)
            this.ngTaskSelectComponent.clearModel();
          this.getTasks();
          this.getTaskCount();
          this.getTaskType();
        }
      }
      else if (navTarget == 'helpContainer') {
        this.masterModel.showHelpPanel = !this.masterModel.showHelpPanel;
      }
      else if (navTarget == 'userContainer') {
        this.masterModel.showUserPanel = !this.masterModel.showUserPanel;
      }
  }
  resetNotificationList() {
    this.masterModel.notifiactionSkip = 0;
    this.masterModel.notificationList = [];
    this.masterModel.todayNotificationList = [];
    this.masterModel.yesterdayNotificationList = [];
    this.masterModel.olderNotificationList = [];
    this.getNotificationStatus();
  }
  resetTaskList() {
    this.masterModel.taskSkip = 0;
    this.masterModel.taskList = [];
    this.masterModel.todayTaskList = [];
    this.masterModel.yesterdayTaskList = [];
    this.masterModel.olderTaskList = [];
  }
  public getTasks() {
    this.masterModel.taskLoader = true;
    const request = new TaskSearchRequest();
    request.skip = this.masterModel.taskSkip;
    request.taskType = this.masterModel.taskType;
    request.isDone = this.masterModel.taskIsDone;
    this.headerService.getTasklist(request)
      .pipe()
      .subscribe(
        res => {
          if (res && res.result == TaskResult.Success) {
            let result = res.data.filter(x => !this.masterModel.taskList.some(y => x.id === y.task.id));
            result.map(x => {
              if (TaskType.InspectionReportFilling || TaskType.AuditReportFilling) {
                let reportNo = x.reportNo && x.reportNo.trim() !== '' ? x.reportNo : x.linkId;
                this.masterModel.taskList.push(new TaskMessage(x, `${x.message} #${reportNo}`,
                  `/${x.link}/${x.linkId}`,
                  x.icon, x.link));
              } else {
                this.masterModel.taskList.push(new TaskMessage(x, `${x.message} #${x.linkId}`,
                  `/${x.link}/${x.linkId}`,
                  x.icon, x.link));
              }
            });
            this.masterModel.todayTaskList = this.masterModel.taskList.filter(x => x.task.dateType == TaskDateType.Today);
            this.masterModel.yesterdayTaskList = this.masterModel.taskList.filter(x => x.task.dateType == TaskDateType.Yesterday);
            this.masterModel.olderTaskList = this.masterModel.taskList.filter(x => x.task.dateType == TaskDateType.Older);
          }
          this.masterModel.taskLoader = false;
        },
        error => {
          this.masterModel.taskLoader = false;
          console.error(error);
        });
  }
  getTaskCount() {
    const request = new TaskSearchRequest();
    request.isDone = this.masterModel.taskIsDone;
    request.taskType = this.masterModel.taskType;

    this.headerService.taskCount(request).subscribe(data => {
      this.masterModel.taskCount = data;
    }, error => {
      console.log(error)
    });
  }
  getTaskType() {
    this.masterModel.taskTypeList = Object.keys(TaskFilterType).filter((v) => isNaN(Number(v))).map((name) => {
      return {
        id: TaskFilterType[name as keyof typeof TaskFilterType],
        name,
      };
    });
    if (this._userTypeId != this._internalusertype)
      this.masterModel.taskTypeList = this.masterModel.taskTypeList
  }
  changeTaskType(type) {
    this.masterModel.showTaskPanel = true;
    this.resetTaskList();
    if (type) {
      this.masterModel.taskType = type.id;
      this.getTasks();
      this.getTaskCount();
    }
    else {
      this.masterModel.taskType = null;
      this.getTasks();
      this.getTaskCount();
    }
    this.masterModel.showTaskPanel = true;
  }
  navigateTaskPage(item: any) {
    if (item === undefined || item.link === null || item.link === '')
      return;
    if (item.task.type == TaskType.InspectionReportFilling || item.task.type == TaskType.AuditReportFilling) {
      this.redirectToFbReport(item.task.linkId);

    } else {
      var featureId = this.getFeatureIdByPath(item.path);
      if (featureId && featureId > 0) {
        this.RedirectWithPath(featureId, item.link);
      } else {
        this.getFeatureIdForNotExistMenu(item.path, item.link);
      }
    }
  }
  navigateNotificationPage(item: any) {
    this.masterModel.showNotificationPanel = false;
    if (item === undefined || item.link === null || item.link === '')
      return;
    var linkuri = '';
    if (item.notification.type == NotificationType.InspectionReportValidated || item.notification.type == NotificationType.AutoInspectionCertificate || item.notification.type == NotificationType.AuditReportValidated) {
      linkuri = `${item.link}2/${item.reportNo}`
    } else if (item.notification.type == NotificationType.PimAttributes || item.notification.type == NotificationType.PimBillOfMaterials || item.notification.type == NotificationType.PimTestingStandard || item.notification.type == NotificationType.PimDocuments) {
      linkuri = `${item.link}${item.linkId}/${item.queryParameter}`
    } else if (item.notification.type == NotificationType.Vendor || item.notification.type == NotificationType.PO || item.notification.type == NotificationType.BookingComment || item.notification.type == NotificationType.AuditComment || item.notification.type == NotificationType.LabBookingComment || item.notification.type == NotificationType.LabReportComment) {
      linkuri = `${item.link}${item.queryParameter}`
    } else if (item.notification.type == NotificationType.PLMSupplier) {
      let obj = { "commentId": item.linkId }
      this.router.navigate(
        [
          `${item.link}${item.queryParameter}`
        ],
        { queryParams: { paramParent: encodeURI(JSON.stringify(obj)) } }
      );
      return
      //  linkuri=`${item.link}${swapIds(item.queryParameter)}`
    }
    else if (item.notification.type == NotificationType.ModelCodeAdded) {
      linkuri = `${item.link}${item.queryParameter}`
    }
    else if (item.notification.type == NotificationType.ApprovedByOperationManager || item.notification.type == NotificationType.RejectedByOperationManager
      || item.notification.type == NotificationType.ApprovedByCustomerServiceManager || item.notification.type == NotificationType.RejectedByCustomerServiceManager
      || item.notification.type == NotificationType.ApprovedByProductManager || item.notification.type == NotificationType.RejectedByProductManager
    ) {
      linkuri = `${item.link}${item.linkId}`
    }
    else {
      if (item.notification.notificationTypeId == NotificationFilterType.PLMCooment) {
        this.router.navigate(
          [
            `${item.link}${item.queryParameter}/${item.linkId}`
          ],
        );
      }
      else {
        if (item?.queryParameter) {
          this.router.navigate(
            [
              `${item.link}${item.queryParameter}`
            ],
          );
        } else {
          this.router.navigate(
            [
              `${item.link}${item.linkId}`
            ],
          );
        }
      }
      return
    }
    var featureId = this.getFeatureIdByPath(item.link);
    if (featureId && featureId > 0) {
      this.RedirectWithPath(featureId, linkuri);
    } else {
      this.getFeatureIdForNotExistMenu(item.link, linkuri);
    }
    // this.router.navigateByUrl(`/shared/blank-page`, { skipLocationChange: true }).then(() => this.router.navigate([linkuri]));
    this.readNotification(item.notification.id);
  }
  redirectToFbReport(reportId: any) {
    this.accService.getUserTokenToFB()
      .subscribe(
        response => {
          if (response != null) {
            var responseurl = response.reportUrl.replace("fullbridge.io//", "fullbridge.io/");
            window.open(responseurl + reportId + "/filling" + "?token=" + response.token, "_blank");
          }
        },
        error => {

        }
      );
  }

  getDoneTask() {
    this.masterModel.taskIsDone = true;
    this.resetTaskList();
    this.getTasks();
    this.getTaskCount();
  }
  clearAllTask() {
    this.masterModel.taskIsDone = false;
    this.masterModel.taskType = null;
    this.ngTaskSelectComponent.clearModel();
    this.resetTaskList();
    this.getTasks();
    this.getTaskCount();
  }
  getNotificationCount() {
    const request = new NotificationSearchRequest();
    request.isRead = this.masterModel.notificationIsRead;
    request.notificationType = this.masterModel.notificationType;

    this.headerService.notificationCount(request).subscribe(data => {
      this.masterModel.notificationCount = data;
    }, error => {
      console.log(error)
    });
  }

  getUnReadTotalNotificationCount() {
    const request = new NotificationSearchRequest();
    request.skip = 0;
    request.notificationType = null;
    request.isRead = false;

    this.headerService.notificationCount(request).subscribe(data => {
      this.masterModel.notifiactionTotalCount = data.totalCount;
    }, error => {
      console.log(error)
    });
  }
  getNotificationType() {
    this.masterModel.notificationTypeList = Object.keys(NotificationFilterType).filter((v) => isNaN(Number(v))).map((name) => {
      return {
        id: NotificationFilterType[name as keyof typeof NotificationFilterType],
        name,
      };
    });
    // if (this._userTypeId != this._internalusertype)
    //   this.masterModel.notificationTypeList = this.masterModel.notificationTypeList.filter(x => x.id == NotificationFilterType.Inspection || x.id == NotificationFilterType.Audit)
  }
  changeNotificationType(notificationType) {
    this.resetNotificationList();
    if (notificationType) {
      this.masterModel.notificationType = notificationType.id;
      this.getNotifications();
      this.getNotificationCount();
    }
    else {
      this.masterModel.notificationType = null;
      this.getNotifications();
      this.getNotificationCount();
    }
  }
  public readAllNotification() {
    this.headerService.readAllNotification()
      .pipe()
      .subscribe(
        res => {
          if (res && res.result == 1) {
            this.getNotificationCount();
            this.getUnReadTotalNotificationCount();
            const todayNotification = this.masterModel.todayNotificationList.filter(x => x.notification.isRead == false);
            if (todayNotification != null && todayNotification.length > 0) {
              todayNotification.forEach(x => x.notification.isRead = true);
            }
            const yesterdayNotification = this.masterModel.yesterdayNotificationList.filter(x => x.notification.isRead == false);
            if (yesterdayNotification != null && yesterdayNotification.length > 0) {
              yesterdayNotification.forEach(x => x.notification.isRead = true);
            }
            const olderNotification = this.masterModel.olderNotificationList.filter(x => x.notification.isRead == false);
            if (olderNotification != null && olderNotification.length > 0) {
              olderNotification.forEach(x => x.notification.isRead = true);
            }
          }
        },
        error => {
          console.error(error);
        });
  }
  clearAllNotification() {
    this.masterModel.notificationIsRead = false;
    this.masterModel.notificationType = null;
    this.getNotificationStatus();
    this.ngNotificationSelectComponent.clearModel();
    this.resetNotificationList();
    this.getNotifications();
    this.getNotificationCount();
  }
  getReadNotification() {
    this.getNotificationStatus();
    this.masterModel.notificationIsRead = !this.masterModel.notificationIsRead;
    this.resetNotificationList();
    this.getNotifications();
    this.getNotificationCount();
  }
  getHeaderSize() {
    let headerSecondColumnLastChildWidth = this.headerSecondColumnLastChild.nativeElement.clientWidth + 20 + 36;
    let availableWidth = this.headerSecondColumnElement.nativeElement.clientWidth - headerSecondColumnLastChildWidth;
    this.calculateHeaderCount(availableWidth);
  }
  getNotificationStatus() {
    if (!this.masterModel.notificationIsRead) {
      return this.utility.textTranslate('HEADER.LBL_UNREAD_NOTIFICATIOM');
    } else {
      return this.utility.textTranslate('HEADER.LBL_READ');
    }
  }
  calculateHeaderCount(availableWidth) {
    let totalWidth = 0;
    this._headercount = 0;
    this.User.rights.forEach(menu => {
      let width = 20 + (menu.titleName?.length * 10);
      totalWidth += width
      if (availableWidth > totalWidth) {
        this._headercount = this._headercount + 1;
      }
    })
  }
  onScroll(event, navTarget) {
    if (navTarget == 'taskContainer' && event.target.offsetHeight + Math.round(event.target.scrollTop) >= (event.target.scrollHeight - NumberOne)) {
      this.masterModel.taskSkip = this.masterModel.taskList.length;
      this.getTasks();
    }
    else if (navTarget == 'notificationContainer' && event.target.offsetHeight + Math.round(event.target.scrollTop) >= (event.target.scrollHeight - NumberOne)) {
      this.masterModel.notifiactionSkip = this.masterModel.notificationList.length;
      this.getNotifications();
    }
  }
  getCountForDisplay(count: number) {
    if (count > 9) {
      return '9+';
    } else {
      return count;
    }
  }
  redirectToUserDashBoard() {
    this.RedirectWithServiceAccess(-1, null);
    let path = "/userDashBoard/dashboard";
    this.router.navigate([`/${path}`]);
  }
  getCustomhightWidth(type: TaskType): string {
    if (type == TaskType.ShipmenttoDispatch || type == TaskType.LabReceivedthesample || type == TaskType.UploadLabReport || type == TaskType.Labcustomerdecision) {
      return "custom_higth_width";
    }
  }
  getNotificationCustomhightWidth(type: NotificationType): string {
    if (type == NotificationType.NewLabbooking || type == NotificationType.LabSampleDispatched || type == NotificationType.LabSampleReceived || type == NotificationType.LabReportAvailable || type == NotificationType.CustomerDecision || type == NotificationType.LabBookingCancel || type == NotificationType.LabReportInvalidated) {
      return "custom_higth_width";
    }
  }
  getFeatureIdByPath(path: string) {
    var extractpath = path.replace(/^[\\\/]+|[\\\/]+$/g, '');
    const matchingItem = this.User.rightsDB.find(outerItem =>
      // Check if status exists in outer item
      (outerItem.path === extractpath) ||
      // Check if status exists in any of the inner list items
      (outerItem.children?.some(innerItem => innerItem.path === extractpath))
    );
    var featureId = matchingItem ? matchingItem.applicationId : -1;
    return featureId;
  }
  getFeatureIdForNotExistMenu(path: string, url: string) {
    var extractpath = path.replace(/^[\\\/]+|[\\\/]+$/g, '');
    var request = { path: extractpath };
    this.headerService.getFeatureIdByPath(request).subscribe(data => {
      this.RedirectWithPath(data, url);
    }, error => {
      console.log(error)
    });
  }
  RedirectWithPath(service, url: string) {
    if (this.expandNavigation)
      this.expandNavigation = !this.expandNavigation;
    this.selectedId = service;
    //set the selected service
    localStorage.setItem('service', JSON.stringify(service));
    //update the current user and assign back to user object
    setTimeout(() => {
      this.User = this.authenticationService.getCurrentUser();
      this.router.navigateByUrl(`/shared/blank-page`, { skipLocationChange: true }).then(() => this.router.navigate([url]));
    }, 500);
    //redirect to page specific to the selected service
  }
}


interface FileReaderEventTarget extends EventTarget {
  result: string
}
interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}


